import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PatientReservationSector } from '../model/patient';
import { PatientAssignation } from '../model/patient/patient-assignation';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PatientAssignationService {

  constructor(  private http: HttpClient,
                private dataService: DataService) { }

  private readonly getPatientAssignationInfoEndPoint: string =
    '/patientAssignation/getPatientAssignationInfo/';

  private readonly assignCoordinatorEndPoint: string =
    '/patientAssignation/assignCoordinator/';

  private readonly assignTherapeuticCompanionEndPoint: string =
    '/patientAssignation/assignTherapeuticCompanion/';

  private readonly unassignTherapeuticCompanionEndPoint: string =
    '/patientAssignation/unassignTherapeuticCompanion/';

  private readonly unassignCoordinatorEndPoint: string =
    '/patientAssignation/UnassignCoordinator/';

  private readonly assignBudgetTimeEndPoint: string =
    '/patientAssignation/assignBudgetTime/';


  async getPatientAssignation(patientId: number): Promise<PatientAssignation> {
    const params = { patientId };
    return await this.dataService
      .get<PatientAssignation>(this.getPatientAssignationInfoEndPoint, params).toPromise();
  }

  async assignBudgetTime(
    patientId: number,
    budgetTime: number,
    ): Promise<boolean> {

  const params = {
    patientId,
    budgetTime
  };

  return this.dataService.post<boolean>
    (this.assignBudgetTimeEndPoint, params)
    .toPromise();
}

  async assignCoordinator(
      patientId: number,
      physicianId: number,
      ): Promise<boolean> {

    const params = {
      patientId,
      physicianId
    };

    return this.dataService.post<boolean>
      (this.assignCoordinatorEndPoint, params)
      .toPromise();
  }

  async assignTherapeuticCompanion(
    patientId: number,
    physicianId: number,
    practiceRegionId: number
    ): Promise<boolean> {

    const params = {
      patientId,
      physicianId,
      practiceRegionId
    };

    return this.dataService.post<boolean>
      (this.assignTherapeuticCompanionEndPoint, params)
      .toPromise();
  }

  async unassignCoordinator(
    patientId: number,
    physicianId: number
    ): Promise<boolean> {

    const params = {
      patientId,
      physicianId
    };

    return this.dataService.post<boolean>
      (this.unassignCoordinatorEndPoint, params)
      .toPromise();
  }


  async unassignTherapeuticCompanion(
    patientId: number,
    physicianId: number
    ): Promise<boolean> {

    const params = {
      patientId,
      physicianId
    };

    return this.dataService.post<boolean>
      (this.unassignTherapeuticCompanionEndPoint, params)
      .toPromise();
  }

}
